/* APEP Biolabs draft: maintains one gifted water unit per eligible peptide unit.
   Discount must be configured separately as Shopify automatic Buy X Get Y.
   Do not publish until multi-item, quantity, checkout and discount tests pass. */
(() => {
  const config = document.getElementById('apep-auto-water-gift');
  if (!config) return;
  const waterVariantId = Number(config.dataset.giftVariantId);
  const eligibleProductIds = new Set(
    (config.dataset.qualifyingProductIds || '').split(',').map(Number).filter(Number.isFinite)
  );
  const giftProperty = '_apep_auto_water_gift';
  const base = window.Shopify?.routes?.root || '/';
  const root = base.endsWith('/') ? base : base + '/';
  const route = (path) => root + path;
  let busy = false;
  let needsAnotherPass = false;
  let timeoutId = null;

  async function jsonRequest(path, payload) {
    const response = await fetch(route(path), {
      method: payload ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: payload ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' },
      body: payload ? JSON.stringify(payload) : undefined,
      cache: 'no-store'
    });
    if (!response.ok) throw new Error('Cart request failed with status ' + response.status);
    return response.json();
  }

  async function synchronize() {
    if (busy) { needsAnotherPass = true; return; }
    busy = true;
    try {
      const cart = await jsonRequest('cart.js');
      const required = cart.items.reduce((total, item) =>
        total + (eligibleProductIds.has(Number(item.product_id)) ? Number(item.quantity) : 0), 0);
      const gifts = cart.items.filter(item =>
        Number(item.variant_id) === waterVariantId && item.properties?.[giftProperty] === 'yes'
      );
      const gift = gifts[0];
      const current = gifts.reduce((n, item) => n + Number(item.quantity), 0);
      if (required === current && gifts.length <= 1) return;

      const sectionIds = [...new Set(
        [...document.querySelectorAll('cart-items-component[data-section-id]')]
          .map(el => el.dataset.sectionId).filter(Boolean)
      )];
      const sections = sectionIds.length ? { sections: sectionIds, sections_url: location.pathname } : {};

      let payload;
      let endpoint;
      if (gift) {
        endpoint = 'cart/change.js';
        payload = { id: gift.key, quantity: required, ...sections };
      } else if (required > 0) {
        endpoint = 'cart/add.js';
        payload = {
          items: [{ id: waterVariantId, quantity: required, properties: { [giftProperty]: 'yes' } }],
          ...sections
        };
      } else {
        return;
      }

      const result = await jsonRequest(endpoint, payload);
      const updatedCart = await jsonRequest('cart.js');
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: updatedCart,
          data: { source: 'apep-auto-water-gift', itemCount: updatedCart.item_count, sections: result.sections || {} }
        }
      }));
      // If another cart event arrived while syncing, the next pass handles it.
    } catch (error) {
      console.warn('APEP automatic water gift could not sync:', error);
    } finally {
      busy = false;
      if (needsAnotherPass) { needsAnotherPass = false; schedule(); }
    }
  }

  function schedule() {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(synchronize, 140);
  }

  document.addEventListener('cart:update', event => {
    if (event.detail?.data?.source !== 'apep-auto-water-gift' && !event.detail?.data?.didError) schedule();
  });
  window.addEventListener('pageshow', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();

  // Product-page accelerated checkout skips the cart and cannot receive the auto-added gift.
  // Require Add to Cart for qualifying product pages until the promotion is validated.
  function hideDirectCheckoutOnEligibleProduct() {
    const onEligibleProduct = [...document.querySelectorAll('product-form-component[data-product-id]')]
      .some(el => eligibleProductIds.has(Number(el.dataset.productId)));
    if (onEligibleProduct && location.pathname.includes('/products/')) {
      const style = document.createElement('style');
      style.textContent = 'shopify-accelerated-checkout, .shopify-payment-button { display: none !important; }';
      document.head.appendChild(style);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hideDirectCheckoutOnEligibleProduct, { once: true });
  else hideDirectCheckoutOnEligibleProduct();
})();
